import React from 'react';
import PropTypes from "prop-types";
import makeStyles from '@mui/styles/makeStyles';
import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import AnnouncmentBackgroundIcon2 from '../../assets/Images/megaphoneIcon2.png';

const useDialogTitleStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minWidth: 550,
    //maxWidth: 500,
    backgroundColor: theme.palette.secondary.light
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    //color: theme.palette.grey[500],
    color: theme.palette.common.white,
  },
  titleTypography:{
    //color: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontSize:"1.5em"
  }
}));

const DialogTitle = (props) => {
  const { children, hideClose, onClose, ...other } = props;
  const classes = useDialogTitleStyles();
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h4" className={classes.titleTypography}>{children}&nbsp;<img src={AnnouncmentBackgroundIcon2} style={{height:32}} alt="announcement"/></Typography>
      {!hideClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
          size="large">
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const useDialogContentStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}));

const DialogContent = (props) => {
  const classes = useDialogContentStyles();
  return <MuiDialogContent className={classes.root} {...props} />;
};

const useDialogActionsStyles = makeStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}));

const DialogActions = (props) => {
  const classes = useDialogActionsStyles();
  return <MuiDialogActions className={classes.root} {...props} />;
};

const AnnouncementDialog = props => {
  const { handleClose, open, titleStyle, title, content, isFullScreen, disableBackdropClick, actions, disableEscapeKeyDown, disableScrollLock, hideClose, dividers } = props;
  return (
    <div>
      <Dialog
        maxWidth="md"
        disableScrollLock={disableScrollLock}
        disableEscapeKeyDown={disableEscapeKeyDown}
        fullScreen={isFullScreen}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}>
        <DialogTitle 
          id="customized-dialog-title" 
          hideClose={hideClose} 
          onClose={handleClose}
          style={titleStyle}
        >
          {title}
        </DialogTitle>
        <DialogContent dividers={dividers}>
          <Typography gutterBottom>
            {content}
          </Typography>
        </DialogContent>
        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    </div>
  );
}

AnnouncementDialog.propTypes = {
  titleStyle: PropTypes.object,
  title: PropTypes.string,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  disableEscapeKeyDown: PropTypes.bool,
  disableScrollLock: PropTypes.bool,
  hideClose: PropTypes.bool,
  content: PropTypes.any,
  actions: PropTypes.any,
  dividers: PropTypes.bool
};

AnnouncementDialog.defaultProps = {
  titleStyle: {},
  title: "",
  open: false,
  content: "",
  handleClose: fn => fn,
  isFullScreen: false,
  actions: "",
  disableBackdropClick: false,
  disableEscapeKeyDown: false,
  disableScrollLock: false,
  hideClose: false,
  dividers: false
};

export default AnnouncementDialog;